import { NgModule } from "@angular/core";

import {
    SpsDescriptionListDefinitionComponent,
    SpsDescriptionListTermComponent,
    SpsDescriptionListComponent,
} from "../components/index";

@NgModule({
    exports: [
        SpsDescriptionListComponent,
        SpsDescriptionListDefinitionComponent,
        SpsDescriptionListTermComponent
    ],
    declarations: [
        SpsDescriptionListComponent,
        SpsDescriptionListDefinitionComponent,
        SpsDescriptionListTermComponent
    ],
})

export class SpsDescriptionListModule {}
